import React from "react";
import CategoriesTable from "./../../CategoriesTable/CategoriesTable";

function CategoryPage() {
  return (
    <CategoriesTable />
  );
}

export default CategoryPage;
